module.exports = __webpack_public_path__ + "static/img/banner.893f7b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplyFinance/banner.png
// module id = avQl
// module chunks = 44